/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesAutoStandardTextAliases {
  ACCEPT_CUSTOM_DYNAMIC_BUTTON = 'accept-custom-dynamic-button',
  CHECKBOX_CLICNICAL_NOTES_MSG = 'checkbox-clicnical-notes-msg',
  FIELD_CLICNICAL_NOTES_MSG = 'field-clicnical-notes-msg',
  LAYOUT_STANDARD_TEXT = 'layout-standard-text',
  LOADER_REPLACED_TEXT = 'loader-replaced-text',
  MODAL_STANDARD_TEXT = 'modal-standard-text',
  PANEL_ACCEPT = 'panel-accept',
  PANEL_LOADER = 'panel-loader',
  PANEL_MESSAGE = 'panel-message',
  TEXT_MESSAGE = 'text-message',
}
export { ClinicalNotesAutoStandardTextAliases };
